import m from "./ghl-ui.es1589.js";
import p from "./ghl-ui.es1590.js";
import f from "./ghl-ui.es1586.js";
import y from "./ghl-ui.es1587.js";
import d from "./ghl-ui.es1588.js";
import c from "./ghl-ui.es1591.js";
import { Parser as w } from "./ghl-ui.es1670.js";
import { mapValue as n, parseNDigits as h } from "./ghl-ui.es1671.js";
import v from "./ghl-ui.es1676.js";
var O = /* @__PURE__ */ function(l) {
  y(e, l);
  var s = d(e);
  function e() {
    var o;
    m(this, e);
    for (var r = arguments.length, i = new Array(r), t = 0; t < r; t++)
      i[t] = arguments[t];
    return o = s.call.apply(s, [this].concat(i)), c(f(o), "priority", 90), c(f(o), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), o;
  }
  return p(e, [{
    key: "parse",
    value: function(r, i, t) {
      var a = function(u) {
        return u === 0 ? 7 : u;
      };
      switch (i) {
        case "i":
        case "ii":
          return h(i.length, r);
        case "io":
          return t.ordinalNumber(r, {
            unit: "day"
          });
        case "iii":
          return n(t.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || t.day(r, {
            width: "short",
            context: "formatting"
          }) || t.day(r, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiiii":
          return n(t.day(r, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiiiii":
          return n(t.day(r, {
            width: "short",
            context: "formatting"
          }) || t.day(r, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiii":
        default:
          return n(t.day(r, {
            width: "wide",
            context: "formatting"
          }) || t.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || t.day(r, {
            width: "short",
            context: "formatting"
          }) || t.day(r, {
            width: "narrow",
            context: "formatting"
          }), a);
      }
    }
  }, {
    key: "validate",
    value: function(r, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(r, i, t) {
      return r = v(r, t), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), e;
}(w);
export {
  O as ISODayParser
};
